import {
  OnThemeFetched,
  OnThemeSelected
} from './theme.types'

export const THEME_FETCHED = 'THEME_FETCHED'
export const THEME_SELECTED = 'THEME_SELECTED'

export const onThemeSelected: OnThemeSelected = (themeName) => ({
  payload: { themeName },
  type: THEME_SELECTED
})

export const onThemeFetched: OnThemeFetched = (theme) => ({
  payload: { theme },
  type: THEME_FETCHED
})
